import styled from 'styled-components'

export const Wrapper = styled.div``

export const Description = styled.div`
  color: #363636;
  font-size: 16px;
  //margin-bottom: 24px;
`

export const RankmiTableWrapper = styled.div`
  .ant-table-wrapper {
    margin-top: -9px;
  }
  .rankmiTable-container > .ant-col {
    justify-content: flex-end;
  }
  .rankmiTable-pagination {
    margin-top: 6px;
  }
`

export const DownloadButton = styled.div`
  button {
    background-color: #e7f3fe !important;
    border-radius: 8px;
    border: none;
    padding: 6px 9px;
    font-weight: bold;
    color: #0085ff !important;
    &:hover {
      color: #0085ffb3 !important;
    }
  }
`
